"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
var pp_react_checkbox_1 = require("@paypalcorp/pp-react-checkbox");
var ajax_util_1 = require("../../../utils/ajax/ajax.util");
var addressErrors_1 = require("../../../utils/errorcodes/addressErrors");
var constants_1 = require("../../../constants");
var route_utils_1 = require("../../../route.utils");
var ROUTES = constants_1.default.ROUTES, VIEWS = constants_1.default.VIEWS, FPTI = constants_1.default.FPTI;
var commonweb_utils_1 = require("commonweb-utils");
var addresses_1 = require("../../../actions/addresses");
var interpolate_component_1 = require("../../../components/interpolate-component");
var triggerOperationResult_1 = require("../../../utils/fpti/triggerOperationResult");
var modalHeader_1 = require("../../../actions/modalHeader");
var constants_2 = require("./constants");
var util_1 = require("util");
var beaver_logger_1 = require("../../../utils/logging/beaver-logger");
var commonUtils_1 = require("../../../common/utils/commonUtils");
var page = require("page");
/**
 * Add address component
 * @author pkatoria
 */
var AddAddress = /** @class */ (function (_super) {
    tslib_1.__extends(AddAddress, _super);
    function AddAddress(props) {
        var _this = _super.call(this, props) || this;
        _this.onClickButton = function (event) {
            _this.setState({ formSubmitted: true });
        };
        _this.inputChangedHandler = function (event, formInputIdentifier) {
            var updatedForm = tslib_1.__assign({}, _this.state.form);
            var updatedFormElement = tslib_1.__assign({}, updatedForm[formInputIdentifier]);
            updatedFormElement.value =
                event.target.type === "checkbox"
                    ? !updatedFormElement.value
                    : event.target.value;
            updatedFormElement.isValid = _this.checkValidity(updatedFormElement.value, updatedFormElement.validation);
            updatedFormElement.isTouched = true;
            updatedForm[formInputIdentifier] = updatedFormElement;
            var formIsValid = true;
            for (var inputIdentifier in updatedForm) {
                if (inputIdentifier !== "stateListInvoked") {
                    formIsValid =
                        updatedForm[inputIdentifier].isValid && formIsValid;
                }
            }
            _this.setState({
                form: updatedForm,
                formIsValid: formIsValid,
                formSubmitted: false,
            });
        };
        _this.getErrorContent = function (errorContent) {
            var customerCareUrl = _this.props.links.help.linkUrl;
            var ccLinkComponent = (React.createElement(pp_react_1.Link, { key: _this.props.commonContent.customerCareLink, href: customerCareUrl }, _this.props.commonContent.customerCareLink));
            var convertedErrorContent = interpolate_component_1.InterpolateLinksWithComponent(errorContent, [ccLinkComponent]);
            return convertedErrorContent;
        };
        // Toggling value of list page visibility in case of mweb
        _this.toggleListPageVisibility = function () {
            var updatedForm = tslib_1.__assign({}, _this.state.form);
            updatedForm["stateListInvoked"] = true;
            _this.props.updateForm(updatedForm);
            var url = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.ADDRESSES.STATE.LIST;
            page(url);
        };
        _this.submitHandler = function (event) {
            event.preventDefault();
            if (_this.state.formIsValid || _this.state.form.formIsValid) {
                _this.setState({ showSpinner: true });
                var formData = {};
                for (var formElementIdentifier in _this.state.form) {
                    formData[formElementIdentifier] = _this.state.form[formElementIdentifier].value;
                }
                var url = ROUTES.API.ADDRESSES.ADD, postData = void 0, addContext_1 = _this.props.addContext;
                if (addContext_1 && addContext_1.type === constants_2.ADDRESS.REMOVE_BILLING_TYPE) {
                    url = ROUTES.API.ADDRESSES.BILLING.REMOVE;
                    postData = {};
                    postData[constants_2.ADDRESS.NEW_BILLING_ADDRESS_KEY] = formData;
                    postData[constants_2.ADDRESS.REMOVE_ADDRESS_ID_KEY] =
                        addContext_1.removeAddressId;
                    postData[constants_2.ADDRESS.REMOVE_PRIMARY_KEY] =
                        addContext_1.isRemovePrimary;
                    postData[constants_2.ADDRESS.CARD_IDS_KEY] = addContext_1.cardIds;
                }
                else {
                    postData = formData;
                    postData["addresses"] = _this.props.addressData.addresses;
                }
                ajax_util_1.default.post$(_this.props.dispatch, _this.props._csrf, url, postData, {
                    component: { name: VIEWS.ADDRESSES.ADD },
                })
                    .then(function (addressInfo) {
                    if (addressInfo) {
                        var flowReturnValue = null, fptiValue = null;
                        var isFlow = _this.props.route.isFlow || false, flowName = _this.props.route.enter.flow || "", isBaseFlowInHistory = commonUtils_1.isBaseFlowPresent(_this.props, ROUTES);
                        _this.props.dispatchAddAddress(addressInfo);
                        var addAction = VIEWS.ADDRESSES.TOAST_INTENTS.ADD;
                        if (addContext_1 &&
                            addContext_1.type === constants_2.ADDRESS.REMOVE_BILLING_TYPE) {
                            if (addContext_1.isRemovePrimary) {
                                addAction =
                                    VIEWS.ADDRESSES.TOAST_INTENTS
                                        .REMOVE_BILLING_PRIMARY_ADD_NEW;
                                flowReturnValue =
                                    constants_2.ADDRESS.FLOW_RETURN_VALUE
                                        .REMOVE_BILLING_ADDRESS_PRIMARY_BY_ADD_NEW;
                                fptiValue = _this.props.addressFpti.billing
                                    .removeBillingAddressPrimaryAddNew;
                            }
                            else if (_this.state.form.primary.value) {
                                addAction =
                                    VIEWS.ADDRESSES.TOAST_INTENTS
                                        .REMOVE_BILLING_ADD_NEW_PRIMARY;
                                flowReturnValue =
                                    constants_2.ADDRESS.FLOW_RETURN_VALUE
                                        .REMOVE_BILLING_ADDRESS_NON_PRIMARY_BY_ADD_NEW_AS_PRIMARY;
                                fptiValue = _this.props.addressFpti.billing
                                    .removeBillingAddressAddNewPrimary;
                            }
                            else {
                                addAction =
                                    VIEWS.ADDRESSES.TOAST_INTENTS
                                        .REMOVE_BILLING_ADD_NEW;
                                flowReturnValue =
                                    constants_2.ADDRESS.FLOW_RETURN_VALUE
                                        .REMOVE_BILLING_ADDRESS_NON_PRIMARY_BY_ADD_NEW;
                                fptiValue = _this.props.addressFpti.billing
                                    .removeBillingAddressAddNew;
                            }
                        }
                        else {
                            if (_this.state.form.primary.value) {
                                addAction =
                                    VIEWS.ADDRESSES.TOAST_INTENTS
                                        .ADD_AS_PRIMARY;
                                if (window &&
                                    window.venice &&
                                    typeof window.venice
                                        .primaryAddressModified === "function") {
                                    window.venice.primaryAddressModified();
                                }
                                flowReturnValue =
                                    constants_2.ADDRESS.FLOW_RETURN_VALUE
                                        .ADD_ADDRESS_PRIMARY;
                                fptiValue = _this.props.addressFpti.addPrimary;
                            }
                            else {
                                addAction = VIEWS.ADDRESSES.TOAST_INTENTS.ADD;
                                flowReturnValue =
                                    constants_2.ADDRESS.FLOW_RETURN_VALUE.ADD_ADDRESS;
                                fptiValue = _this.props.addressFpti.add;
                            }
                        }
                        if (addAction ===
                            VIEWS.ADDRESSES.TOAST_INTENTS.ADD_AS_PRIMARY ||
                            addAction ===
                                VIEWS.ADDRESSES.TOAST_INTENTS
                                    .REMOVE_BILLING_ADD_NEW_PRIMARY ||
                            addAction ===
                                VIEWS.ADDRESSES.TOAST_INTENTS
                                    .REMOVE_BILLING_PRIMARY_ADD_NEW) {
                            if (window &&
                                window.venice &&
                                typeof window.venice.primaryAddressModified ===
                                    "function") {
                                window.venice.primaryAddressModified();
                            }
                        }
                        _this.props.addAction(addAction);
                        if (addressInfo.ppcSynchronyDeeplinks &&
                            Object.keys(addressInfo.ppcSynchronyDeeplinks)
                                .length != 0) {
                            var ppcedit = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.ADDRESSES.EDIT_PPC;
                            page.redirect(ppcedit);
                        }
                        else {
                            if (isFlow && !isBaseFlowInHistory) {
                                triggerOperationResult_1.triggerOperationResult(fptiValue, FPTI.SUCCESS, null);
                                route_utils_1.transitionOutHandler();
                                page(constants_1.default.BASE_URI + "/flow-return/" + flowName + "?success=" + flowReturnValue);
                            }
                            else {
                                if (addContext_1 &&
                                    addContext_1.type ===
                                        constants_2.ADDRESS.REMOVE_BILLING_TYPE) {
                                    window.history.go(-2);
                                }
                                else {
                                    page.back();
                                }
                            }
                        }
                    }
                })
                    .catch(function (error) {
                    _this.setState({ showSpinner: false });
                    var addressContent = _this.props.addressContent;
                    if (error && error.userError) {
                        for (var i = 0; i < error.userError.errors.length; i++) {
                            var currentError = error.userError.errors[i];
                            if (currentError.name ===
                                "ADDRESS_PATTERN_VALIDATION_ERROR" &&
                                currentError.detail.field === "postal_code") {
                                _this.setState({
                                    errorMsgPostalCode: addressContent.addUpdate.invalidZipCode,
                                });
                            }
                        }
                        return;
                    }
                    var errorStatusCode = commonweb_utils_1.objectUtils.safeGet(error, "statusCode") || 500;
                    var errorDescFPTI;
                    beaver_logger_1.default().info(constants_2.ADDRESS.ADD_ADDRESS, {
                        errorCode: errorStatusCode,
                        message: error && error.message,
                    });
                    if (errorStatusCode >= 400 && errorStatusCode < 500) {
                        var code = addressErrors_1.errorCodes[error.errorKey];
                        var errorContent = _this.props.addressContent.error[code];
                        if (!errorContent) {
                            errorContent = _this.getErrorContent(_this.props.commonContent.error.errorGeneric);
                        }
                        _this.setState({ errorMessage: errorContent });
                        errorDescFPTI = errorContent;
                    }
                    else {
                        var errorContent = _this.getErrorContent(_this.props.commonContent.error.errorGeneric);
                        _this.setState({ errorMessage: errorContent });
                        errorDescFPTI = errorContent;
                    }
                    var fptiOperationType = _this.props.addressFpti.add;
                    if (addContext_1 &&
                        addContext_1.type === constants_2.ADDRESS.REMOVE_BILLING_TYPE) {
                        fptiOperationType = _this.props.addressFpti.billing
                            .addNew;
                    }
                    triggerOperationResult_1.triggerOperationResult(fptiOperationType, FPTI.FAILURE, errorDescFPTI);
                    return;
                });
            }
        };
        var countryCode = _this.props.addressData.newAddress.country;
        var properties = commonweb_utils_1.objectUtils.safeGet(_this.props, "addressData.newAddress.entryMetadata.properties");
        var stateList = properties && properties.state ? properties.state.list : [];
        _this.state = {
            form: {
                line1: {
                    value: "",
                    validation: {
                        required: commonweb_utils_1.objectUtils.safeGet(properties, "line1") &&
                            commonweb_utils_1.objectUtils.safeGet(properties, "line1").required,
                        suggestionText: commonweb_utils_1.objectUtils.safeGet(_this.props, "addressContent.addUpdate.invalidStreet"),
                    },
                    isValid: false,
                    isTouched: false,
                },
                line2: {
                    value: "",
                    validation: {
                        required: commonweb_utils_1.objectUtils.safeGet(properties, "line2") &&
                            commonweb_utils_1.objectUtils.safeGet(properties, "line2").required,
                        suggestionText: " ",
                    },
                    isValid: true,
                    isTouched: false,
                },
                city: {
                    value: "",
                    validation: {
                        required: commonweb_utils_1.objectUtils.safeGet(properties, "city") &&
                            commonweb_utils_1.objectUtils.safeGet(properties, "city").required,
                        suggestionText: commonweb_utils_1.objectUtils.safeGet(_this.props, "addressContent.addUpdate.invalidCity"),
                    },
                    isValid: commonweb_utils_1.objectUtils.safeGet(properties, "city") ? false : true,
                    isTouched: false,
                },
                state: {
                    value: "undefined",
                    validation: {
                        required: commonweb_utils_1.objectUtils.safeGet(properties, "state") &&
                            commonweb_utils_1.objectUtils.safeGet(properties, "state").required,
                        suggestionText: commonweb_utils_1.objectUtils.safeGet(_this.props, "addressContent.addUpdate.invalidState"),
                    },
                    isValid: commonweb_utils_1.objectUtils.safeGet(properties, "state") ? false : true,
                    isTouched: false,
                },
                postal_code: {
                    value: "",
                    validation: {
                        required: commonweb_utils_1.objectUtils.safeGet(properties, "postal_code") &&
                            commonweb_utils_1.objectUtils.safeGet(properties, "postal_code").required,
                        pattern: commonweb_utils_1.objectUtils.safeGet(properties, "postal_code")
                            ? commonweb_utils_1.objectUtils.safeGet(properties, "postal_code")
                                .validationPattern
                            : "",
                        maxlength: commonweb_utils_1.objectUtils.safeGet(properties, "postal_code") &&
                            commonweb_utils_1.objectUtils.safeGet(properties, "postal_code").maxLength
                            ? commonweb_utils_1.objectUtils.safeGet(properties, "postal_code").maxLength
                            : null,
                        suggestionText: commonweb_utils_1.objectUtils.safeGet(_this.props, "addressContent.addUpdate.invalidZipCode"),
                    },
                    isValid: commonweb_utils_1.objectUtils.safeGet(properties, "postal_code")
                        ? false
                        : true,
                    isTouched: false,
                },
                country_code: {
                    value: countryCode,
                    validation: {
                        required: false,
                    },
                    isValid: true,
                    isTouched: false,
                },
                primary: {
                    value: false,
                    validation: {
                        required: false,
                    },
                    isValid: true,
                    isTouched: false,
                },
            },
            formIsValid: false,
            errorMessage: "",
            formSubmitted: false,
            showSpinner: false,
            value: "",
            label: "",
            suggestions: stateList,
            openListPage: false,
            innerWidth: window.innerWidth,
            errorMsgPostalCode: "",
        };
        return _this;
    }
    /**
     * This function is used to set the innerwidth so that for small width screesn dropdown
     * can be converted into a list page
     */
    AddAddress.prototype.updateDimensions = function () {
        if (window.innerWidth < 641) {
            this.setState({ innerWidth: 500 });
        }
        else {
            this.setState({ innerWidth: 1000 });
        }
    };
    /**
     * Add event listener to detect screen size change on responsive screens.
     */
    AddAddress.prototype.componentDidMount = function () {
        if (this.props.updatedForm) {
            this.setState({
                form: this.props.updatedForm,
            });
        }
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));
    };
    AddAddress.prototype.checkValidity = function (value, rules) {
        var isValid = true;
        if (!rules) {
            return true;
        }
        if (rules.required) {
            isValid = value.trim() !== "" && isValid;
        }
        if (rules.maxLength) {
            isValid = value.length <= rules.maxLength && isValid;
        }
        if (rules.pattern) {
            var pattern = new RegExp("^" + rules.pattern + "$");
            isValid = pattern.test(value) && isValid;
        }
        return isValid;
    };
    AddAddress.prototype.inputElement = function (item, key) {
        var _this = this;
        var formElement = tslib_1.__assign({}, this.state.form[key]);
        var isInputValid = this.state.formSubmitted
            ? formElement.isValid
            : true;
        if (key === "line1") {
            return (React.createElement(pp_react_1.TextInput, { errorText: !isInputValid
                    ? formElement.validation.suggestionText
                    : "", disabled: this.state.showSpinner, id: key, className: "formFields_space", name: key, value: formElement.value, label: item.label, onChange: function (event) { return _this.inputChangedHandler(event, key); } }));
        }
        else if (key === "line2") {
            return (React.createElement(pp_react_1.TextInput, { disabled: this.state.showSpinner, id: key, className: "formFields_space", name: key, value: formElement.value, label: item.label, onChange: function (event) { return _this.inputChangedHandler(event, key); } }));
        }
        else if (key === "city") {
            if (item.list) {
                return (React.createElement(pp_react_1.Dropdown, { disabled: this.state.showSpinner, className: "formFields_space", name: key, value: formElement.value, label: item.label, placeholder: "", id: key, errorText: !isInputValid
                        ? formElement.validation.suggestionText
                        : "", options: item.list.map(function (city) {
                        return {
                            label: city.label,
                            value: city.id,
                        };
                    }), onChange: function (event) {
                        return _this.inputChangedHandler(event, key);
                    } }));
            }
            else {
                return (React.createElement(pp_react_1.TextInput, { errorText: !isInputValid
                        ? formElement.validation.suggestionText
                        : "", disabled: this.state.showSpinner, className: "formFields_space", id: key, name: key, value: formElement.value, label: item.label, onChange: function (event) {
                        return _this.inputChangedHandler(event, key);
                    } }));
            }
        }
        else if (key === "state") {
            var selectedState = this.props.stateList &&
                formElement &&
                this.props.stateList.find(function (state) { return state.id === formElement.value; });
            if (item.list) {
                return (React.createElement("div", null, this.state.innerWidth > 640 ? (React.createElement(pp_react_1.Dropdown, { className: "formFields_space", errorText: "", disabled: this.state.showSpinner, value: formElement.value === "undefined"
                        ? ""
                        : formElement.value, name: key, label: item.label, placeholder: "", id: key, options: item.list.map(function (state) {
                        return {
                            label: state.label,
                            value: state.id,
                        };
                    }), onChange: function (event) {
                        return _this.inputChangedHandler(event, key);
                    } })) : (React.createElement(pp_react_1.Dropdown, { className: "formFields_space", errorText: !isInputValid
                        ? formElement.validation.suggestionText
                        : "", disabled: this.state.showSpinner, value: selectedState
                        ? selectedState.id
                        : formElement.value, name: key, label: item.label, placeholder: "", id: key, options: [
                        {
                            label: selectedState
                                ? selectedState.label
                                : formElement.label,
                            value: selectedState
                                ? selectedState.id
                                : formElement.value,
                        },
                    ], onClick: function (event) {
                        return _this.toggleListPageVisibility();
                    } }))));
            }
            else {
                return (React.createElement(pp_react_1.TextInput, { errorText: !isInputValid
                        ? formElement.validation.suggestionText
                        : "", disabled: this.state.showSpinner, className: "formFields_space", id: key, name: key, value: formElement.value === "undefined"
                        ? ""
                        : formElement.value, label: item.label, onChange: function (event) {
                        return _this.inputChangedHandler(event, key);
                    } }));
            }
        }
        else if (key === "postal_code") {
            isInputValid = this.state.formSubmitted
                ? commonweb_utils_1.objectUtils.safeGet(this.state, "form.postal_code.isValid")
                : true;
            return (React.createElement(pp_react_1.TextInput, { errorText: commonweb_utils_1.objectUtils.safeGet(this.state, "errorMsgPostalCode")
                    ? commonweb_utils_1.objectUtils.safeGet(this.state, "errorMsgPostalCode")
                    : !isInputValid
                        ? commonweb_utils_1.objectUtils.safeGet(this.state, "form.postal_code.validation.suggestionText")
                        : "", disabled: this.state.showSpinner, className: "formFields_space", id: "postal_code", name: "postal_code", value: this.state.form.postal_code &&
                    this.state.form.postal_code.value, label: item.label, onChange: function (event) {
                    return _this.inputChangedHandler(event, "postal_code");
                } }));
        }
    };
    AddAddress.prototype.render = function () {
        var _this = this;
        var formElementsArray = [];
        var addressFpti = this.props.addressFpti;
        for (var key in this.state.form) {
            formElementsArray.push({
                id: key,
                config: this.state.form[key],
            });
        }
        var properties = commonweb_utils_1.objectUtils.safeGet(this.props, "addressData.newAddress.entryMetadata.properties"), layout = commonweb_utils_1.objectUtils.safeGet(this.props, "addressData.newAddress.entryMetadata.layout");
        var addressInput = layout.map(function (lines) {
            return util_1.isArray(lines) &&
                lines.map(function (addressKey) {
                    return _this.inputElement(properties[addressKey], addressKey);
                });
        });
        //start : searchBox related code
        //@ts-ignore
        var addContextType = commonweb_utils_1.objectUtils.safeGet(this.props, "addContext.type"), billingRemove = addContextType === constants_2.ADDRESS.REMOVE_BILLING_TYPE, billingRemovePrimary = commonweb_utils_1.objectUtils.safeGet(this.props, "addContext.isRemovePrimary") || false;
        function shouldRenderSuggestions(value) {
            return value.trim().length > -1;
        }
        //end searchBox related code
        var form = (React.createElement("form", { id: "add_address_form", onSubmit: this.submitHandler },
            this.state.errorMessage && (React.createElement(pp_react_1.Alert, { type: "error", className: "form-alert" }, this.state.errorMessage)),
            billingRemove ? (React.createElement(pp_react_1.Text, { className: "genericAccountHeader", size: "xl3" }, this.props.addressContent.removeBilling.addNewAddress)) : (React.createElement(pp_react_1.Text, { className: "genericAccountHeader", size: "xl3" }, this.props.addressContent.addNew.header)),
            addressInput,
            !billingRemovePrimary && (
            // @ts-ignore
            React.createElement(pp_react_checkbox_1.Checkbox, { className: "checkbox_space test_makeAddressPrimary", disabled: this.state.showSpinner, id: "primary", label: this.props.addressContent.addNewSetPrimary.checkBox, name: addressFpti.makePrimaryCheckbox, onChange: function (event) {
                    return _this.inputChangedHandler(event, "primary");
                } })),
            React.createElement(pp_react_1.Button, { className: "addUpdateButton_space fullWidth test_AddUpdateButton", name: billingRemove
                    ? addressFpti.billing.submitAddNew
                    : addressFpti.submitAdd, type: "submit", disabled: this.state.showSpinner, onClick: function (event) { return _this.onClickButton(event); } }, this.state.showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "loading-spinner", screenReaderText: "loading", inverse: true })) : (this.props.addressContent.addAddress.button))));
        return React.createElement("div", null, form);
    };
    return AddAddress;
}(React.Component));
var mapStateToProps = function (_a, ownProps) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account, links = _a.links, fpti = _a.fpti, deviceInfo = _a.deviceInfo;
    var addressData = account.addressData, addressFpti = fpti.address, properties = commonweb_utils_1.objectUtils.safeGet(addressData, "newAddress.entryMetadata.properties"), stateList = properties && properties.state ? properties.state.list : [], addressContent = content.addresses, commonContent = content.common, showNavigation = account.showNavigation, addContext = ownProps && ownProps.addContext, updatedForm = addressData.updatedForm;
    return {
        _csrf: _csrf,
        ui: ui,
        content: content,
        route: route,
        addressData: addressData,
        addressContent: addressContent,
        commonContent: commonContent,
        links: links,
        addressFpti: addressFpti,
        stateList: stateList,
        showNavigation: showNavigation,
        deviceInfo: deviceInfo,
        addContext: addContext,
        updatedForm: updatedForm,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatchAddAddress: function (addressInfo) {
            return dispatch(addresses_1.buildAddress(addressInfo));
        },
        addAction: function (typeOfAction) { return dispatch(addresses_1.actionType(typeOfAction)); },
        changeHeaderVisibility: function (value) { return dispatch(modalHeader_1.showNavigation(value)); },
        updateForm: function (value) { return dispatch(addresses_1.updateForm(value)); },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(AddAddress);
